import closeIcon from "assets/icons/close-gray.svg";
import React from 'react';

const EmailBox = ({
  email,
  image,
  color,
  removeEmail,
  defaultEmailText
}) => {
  return (
    <div className='emails__card'>
      {!defaultEmailText && (
        <div className="emails__card-image" style={{ backgroundColor: color }}>
          <span>
            {image}
          </span>
        </div>
      )}
      <div className="emails__card-name">{defaultEmailText ? defaultEmailText : email}</div>
      {!defaultEmailText && (
        <button className="emails__card-close"
          onClick={() => removeEmail(email)}
        >
         {removeEmail && <img src={closeIcon} alt="" />} 
        </button>
      )}
    </div>
  )
}

export default EmailBox